import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  timeDifference: number;
  allowTime: number;
  timeSynced: boolean;
} = {
  timeDifference: 0,
  allowTime: 0,
  timeSynced: false,
};

const settings = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setTimeDifference: (state, action) => {
      state.timeDifference = action.payload;
    },
    setHMACAllowTime: (state, action) => {
      state.allowTime = action.payload;
    },
    setTimeSynced: (state, action) => {
      state.timeSynced = action.payload;
    },
  },
});

export const { setTimeDifference, setHMACAllowTime, setTimeSynced } = settings.actions;

export default settings;
